var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19V22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19Z",
    fill: "#7D8592",
    stroke: "#7D8592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H5V18H7V11Z",
    fill: "#7D8592"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H9V18H11V11Z",
    fill: "#7D8592"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H13V18H15V11Z",
    fill: "#7D8592"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H17V18H19V11Z",
    fill: "#7D8592"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22.75H1C0.59 22.75 0.25 22.41 0.25 22C0.25 21.59 0.59 21.25 1 21.25H23C23.41 21.25 23.75 21.59 23.75 22C23.75 22.41 23.41 22.75 23 22.75Z",
    fill: "#7D8592"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.37 5.75009L12.37 2.15009C12.17 2.07009 11.83 2.07009 11.63 2.15009L2.63 5.75009C2.28 5.89009 2 6.30009 2 6.68009V10.0001C2 10.5501 2.45 11.0001 3 11.0001H21C21.55 11.0001 22 10.5501 22 10.0001V6.68009C22 6.30009 21.72 5.89009 21.37 5.75009ZM12 8.50009C11.17 8.50009 10.5 7.83009 10.5 7.00009C10.5 6.17009 11.17 5.50009 12 5.50009C12.83 5.50009 13.5 6.17009 13.5 7.00009C13.5 7.83009 12.83 8.50009 12 8.50009Z",
    fill: "#7D8592"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProfileIcon);
export default __webpack_public_path__ + "static/media/sidebarProfileIcon.8353f1d928a25f83f7b5dbd172250823.svg";
export { ForwardRef as ReactComponent };